// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister old CRA service workers but leave firebase-messaging-sw.js intact
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(r => {
      if (!r.active?.scriptURL?.includes("firebase-messaging-sw")) {
        r.unregister();
      }
    });
  });
}
